function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_45891_24614)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.39744 1.34793C3.52643 1.03653 3.83029 0.833496 4.16734 0.833496H15.834C16.2942 0.833496 16.6673 1.20659 16.6673 1.66683V7.50016C16.6673 7.9604 16.2942 8.3335 15.834 8.3335H12.0125L16.4233 12.7442C16.6616 12.9826 16.7329 13.341 16.6039 13.6524C16.4749 13.9638 16.1711 14.1668 15.834 14.1668H10.834V19.1668C10.834 19.5039 10.631 19.8077 10.3196 19.9367C10.0082 20.0657 9.64975 19.9944 9.41142 19.7561L3.57853 13.9232C3.4285 13.7732 3.34422 13.5751 3.33486 13.3716M3.33401 13.3269V7.50016C3.33401 7.03993 3.7071 6.66683 4.16734 6.66683H7.98883L3.57809 2.25609C3.33975 2.01775 3.26846 1.65932 3.39744 1.34793M10.3459 6.66683H15.0007V2.50016H6.17919L10.3459 6.66683ZM9.6555 8.3335H5.00068V12.5002H13.8222L9.6555 8.3335ZM9.16734 14.1668H6.17919L9.16734 17.155V14.1668Z",
  fill: "#C7E8FE"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_45891_24614"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgCongress = function SvgCongress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCongress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/congress.aa02b62a.svg";
export { ForwardRef as ReactComponent };